import { render, staticRenderFns } from "./UnitProcess.vue?vue&type=template&id=f5c5b3b2"
import script from "./UnitProcess.vue?vue&type=script&lang=js"
export * from "./UnitProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports